import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Collapse, CardBody, Card } from 'reactstrap';
import Icon from '@mdi/react';
import { mdiChevronLeft, mdiChevronDown, mdiToolbox, mdiHelpCircleOutline } from '@mdi/js';
import './collapsemenu.scss';
import { InformationModalIcon } from '../InformationModal/InformationModal';

interface ICollapseMenuProps {
  title: string;
  cardBodyId?: string;
  noIcon?: boolean;
  forceOpen?: boolean;
  footer?: JSX.Element;
  icon?: string;
  isOpen?: boolean;
  titleClass?: string;
  bodyContainerId?: string;
  children?: React.ReactNode;
  className?: string;
  showAsHeader?: boolean;
  sectionHelp?: boolean;
  sectionHelpCallback?: () => void;
}
const CollapseMenuComponent = (props: ICollapseMenuProps) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (props.forceOpen) {
      setIsOpen(true);
    }
  }, [props.forceOpen]);

  useEffect(() => {
    if (props.isOpen) {
      setIsOpen(props.isOpen);
    }
  }, [props.isOpen]);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <div className={props.className ? props.className : 'mb-3'}>
      <button
        className="set-collapse display-flex justify-content-between"
        color="primary"
        onClick={toggle}
        aria-controls={props?.bodyContainerId}
        aria-expanded={isOpen}
      >
        <span className={props?.titleClass}>
          {/* Menu adds Icon by default. If you want no icon in your menu, set noIcon={true} when you add the menu to your component */}
          {!props.noIcon && <Icon className="mr-2" path={props.icon || mdiToolbox} title="" size={1} color="#005ea2" />}{' '}
          {props.showAsHeader ? <h1 className="h5 mt-1 mb-1">{props.title}</h1> : props.title}
          {(props.sectionHelp && props.sectionHelpCallback !== undefined) ? 
            <InformationModalIcon modalTriggerCallback={props.sectionHelpCallback} title={props.title} /> 
          : null}
        </span>
        <span>
          <Icon path={isOpen ? mdiChevronDown : mdiChevronLeft} title="" size={1} color="#005ea2" />
        </span>
      </button>
      <Collapse className="set-collapse-body" isOpen={isOpen}>
        <Card className="collapse-body-container" id={props?.bodyContainerId}>
          <CardBody className="collapse-body" id={props?.cardBodyId}>
            {props.children}
          </CardBody>
        </Card>
      </Collapse>
      {props.footer !== undefined ? <div className="set-collapse-footer">{props.footer}</div> : null}
    </div>
  );
};

export const CollapseMenu = observer(CollapseMenuComponent);
